import { useTranslation } from 'react-i18next';
import { TOperationPeriod } from '@/common/integrations/menhir/employee/operations/operations.types';
import { Nullable } from '@/common/types/general';
import { INTL_MONTH_DAY_SHORT_FORMAT, intlFormat } from '@/common/utils/date';
import { FloatingSelectField } from '@coverflex-tech/hypernova';

export const OperationPeriodDropdown = ({
  periods,
  period,
  setPeriod,
  disabled,
}: TOperationPeriodDropdownProps) => {
  const { t } = useTranslation();

  return (
    <FloatingSelectField
      id="operation-period-dropdown"
      label={t('general.labels.filter_by_date')}
      value={period}
      options={periods}
      onChange={(_, v) => setPeriod(v)}
      disabled={disabled}
      itemToString={(p) =>
        `${intlFormat(p?.startsOn, INTL_MONTH_DAY_SHORT_FORMAT)} - ${intlFormat(
          p?.endsOn,
          INTL_MONTH_DAY_SHORT_FORMAT
        )}`
      }
    />
  );
};

export type TOperationPeriodDropdownProps = {
  periods: TOperationPeriod[];
  period: Nullable<TOperationPeriod>;
  setPeriod: (period: Nullable<TOperationPeriod>) => void;
  disabled?: boolean;
};
